import { render, staticRenderFns } from "./PixcelDashboard.vue?vue&type=template&id=7486ab7d&"
import script from "./PixcelDashboard.vue?vue&type=script&lang=js&"
export * from "./PixcelDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/aims-dashboard/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7486ab7d')) {
      api.createRecord('7486ab7d', component.options)
    } else {
      api.reload('7486ab7d', component.options)
    }
    module.hot.accept("./PixcelDashboard.vue?vue&type=template&id=7486ab7d&", function () {
      api.rerender('7486ab7d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lcd/views/PixcelDashboard.vue"
export default component.exports